import React from 'react';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';
import { diffWords, diffArrays } from 'diff';

class CorrectedWordCounter extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      count: props.value
    };
  }

  componentDidMount () {
    PubSub.subscribe('DICTATION_COUNT_ERRORS', (_msg, data) => this.onChange(data));
  }

  getCorrectionCount(state) {
    let diff = diffArrays(state.initialValues, state.values);

    return diff.filter(obj => obj.added).reduce((acc, obj) => acc + obj.count, 0);
  }

  onChange (state) {
    this.setState({ count: this.getCorrectionCount(state) });
  }

  render() {
    let wordCounterStateClass;

    if (this.state.count === this.props.maxLength) {
      wordCounterStateClass = "text-success font-bold";
    } else {
      wordCounterStateClass = "text-danger font-bold";
    }

    return (
      <div className={`${wordCounterStateClass}`}>{this.state.count}</div>
    );
  }
}

CorrectedWordCounter.propTypes = {
  value: PropTypes.number,
  maxLength: PropTypes.number,
};

CorrectedWordCounter.defaultProps = {
  value: 0
};

export default CorrectedWordCounter;
